module.exports = __webpack_public_path__ + "44bf5414899484be7657132a38b8b12b.pdf";